import {Action} from "redux";
import {isQueriesWidgetAction, QueriesWidgetAction} from "./actions";
import {CategoryId} from "../../lib/category-manager/data";
import {Query, QueryCategoryMap, QueryId, QueryTitleMap} from "./data";

export type State = {
	selectedCategories: CategoryId[]
	selectedQueries: QueryId[]
	visibleQueries: QueryId[]
	titleMap: QueryTitleMap
}

export const reducer = (q: Query[], map: QueryCategoryMap) => (s: State, a: Action): State => {
	if(isQueriesWidgetAction(a)) {
		return queriesWidgetReducer(q, map, s, a.action)
	}
	return s
}

/**
 * filterCategories => [1,2]
 * map[q.id] => [2,3]
 * difference => [1]
 * this indicates that query q is not in all the selected categories, thus filter out of list
 */
const filterQueries = (queries: Query[], map: QueryCategoryMap, filterCategories: CategoryId[]): Query[] => {
	return filterCategories.length == 0
		? queries
		: queries.filter((q:Query) => {
			return map[q.id] && _.difference(filterCategories, map[q.id]).length === 0
		})
}

const queriesWidgetReducer = (q: Query[], map: QueryCategoryMap, s: State, a: QueriesWidgetAction): State => {
	switch (a.type) {
		case "set category filters":
			const visibleQueries = filterQueries(q, map, a.categories).map(q => q.id).concat(s.selectedQueries)
			return {...s, selectedCategories: a.categories, visibleQueries}
		case "set query checkbox":
			const v: QueryId[] = [a.query]
			return {...s, selectedQueries: v.concat(s.selectedQueries)}
		case "unset query checkbox":
			return {...s, selectedQueries: s.selectedQueries.filter(qid => qid != a.query)}
	}
}



// WEBPACK FOOTER //
// ./src/communications/queries-widget/reducers.ts